// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__205-Y","col":"CardReaderDesc_col__xhQgg","label":"CardReaderDesc_label__15DCm"};